module.exports = new __parcel__URL__("decodable_logo_white.b6ed06d8.svg").toString();